import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBB1 } from "../../../../../redux/app/crb/groups/crb-b";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBB1PreviewProps = OwnProps;
function CRBB1Preview(props: CRBB1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBB1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "B", "_", renderItemDateTime()],
					[null, null, "4", renderItem4()],
					[null, null, "5", renderItem5()],
					[null, null, "6", renderItem6()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItemDateTime() {
		const { startDate, startTime, endDate, endTime } = crbRecord.item4P2;
		const startDateTimeLocal = `${startDate}T${startTime}:00${crbRecord.timeZone}`;
		const startUtcTime = moment.utc(startDateTimeLocal);
		const endDateTimeLocal = `${endDate}T${endTime}:00${crbRecord.timeZone}`;
		const endUtcTime = moment.utc(endDateTimeLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Commenced At: {startUtcTime.format("HH:mm")} hrs (UTC) ({startTime}{" "}
					SMT)
				</h4>
				<h4 className="font-medium uppercase">
					Stopped At: {endUtcTime.format("HH:mm")} hrs (UTC) ({endTime} SMT)
				</h4>
			</>
		);
	}

	function getFromTanks() {
		if (crbRecord.item4.tanks.length > 0) {
			return (
				<table className="min-w-full table-auto border-collapse">
					<thead className="bg-gray-600">
						<tr>
							<th className="px-4 py-2 border text-center">Tank</th>
							<th className="px-4 py-2 border text-center">
								Transfer Quantity
							</th>
							<th className="px-4 py-2 border text-center">Substance</th>
							<th className="px-4 py-2 border text-center">Category</th>
						</tr>
					</thead>
					<tbody>
						{crbRecord.item4.tanks.map((tank) => {
							return (
								<tr key={tank.selectedTank.id}>
									<td className="px-4 py-2 border text-center">
										{tank.selectedTank.tankCode}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.transferQuantity}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.substance}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.catgeory}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			);
		}
		return <>----</>;
	}
	function getToTanks() {
		if (crbRecord.item4P1.destinationTanks.length > 0) {
			return (
				<table className="min-w-full table-auto border-collapse">
					<thead className="bg-gray-600">
						<tr>
							<th className="px-4 py-2 border text-center">Tank</th>
							<th className="px-4 py-2 border text-center">
								Received Quantity
							</th>
							<th className="px-4 py-2 border text-center">Substance</th>
							<th className="px-4 py-2 border text-center">Category</th>
						</tr>
					</thead>
					<tbody>
						{crbRecord.item4P1.destinationTanks.map((tank) => {
							return (
								<tr key={tank.selectedTank.id}>
									<td className="px-4 py-2 border text-center">
										{tank.selectedTank.tankCode}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.transferQuantity}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.substance}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.catgeory}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			);
		}
		return <>----</>;
	}

	function renderItem4() {
		const totalQuantityTransferred = crbRecord.item4.tanks.reduce<number>(
			(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
			0
		);
		return (
			<h4 className="font-medium uppercase">
				<>From Tanks:</>
				{getFromTanks()}
				<br />
				<>To Tanks:</>
				{getToTanks()}
				<br />
				<>Total Cargo Transferred: {totalQuantityTransferred.toFixed(2)} M³</>
			</h4>
		);
	}

	function renderItem5() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item5.wereTanksEmptied ? "YES" : "NO"}
			</h4>
		);
	}

	function renderItem6() {
		if (crbRecord.item4.tanks.length > 0) {
			return (
				<h4 className="font-medium uppercase">
					{!crbRecord.item5.wereTanksEmptied ? (
						<>
							<table className="min-w-full table-auto border-collapse">
								<thead className="bg-gray-600">
									<tr>
										<th className="px-4 py-2 border text-center">Tank</th>
										<th className="px-4 py-2 border text-center">
											Quantity Remaining
										</th>
									</tr>
								</thead>
								<tbody>
									{crbRecord.item4.tanks.map((tank) => {
										return (
											<tr key={tank.selectedTank.id}>
												<td className="px-4 py-2 border text-center">
													{tank.selectedTank.tankCode}
												</td>
												<td className="px-4 py-2 border text-center">
													{tank.newQuantity}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</>
					) : (
						<>----</>
					)}
				</h4>
			);
		}
		return <>----</>;
	}

	return renderMain();
}

export default CRBB1Preview;
